export const endpoints = {
  auth: {
    profile: '/auth/me',
    login: '/auth/login',
    resetPassword: '/auth/reset-password',
    refreshToken: '/auth/refresh-token',
  },
  materialCategories: '/materialCategories',
  clients: {
    default: '/clients',
  },
  salons: {
    default: '/salons',
  },
  users: {
    default: '/admin-profiles',
  },
  notes: {
    default: '/notes',
  },
  attachments: {
    default: '/attachments',
    upload: '/attachments/files',
  },
  responsibilities: {
    default: '/responsibilities',
  },
  materials: {
    default: '/materials',
    syncData: '/materials/sync',
  },
  collections: {
    default: '/collections',
    syncData: '/collections/sync',
    export: '/collections/export',
  },
  sku: {
    default: '/sku',
    syncData: '/sku/sync',
    export: '/sku/export',
  },
  models: '/models',
  productCategories: '/productCategories',
  product: {
    default: 'products',
    syncData: '/products/sync',
  },
  parts: {
    default: 'parts',
    partGroups: 'partGroups',
  },
  colors: {
    default: '/colors',
  },
  shades: 'shades',
  plans: {
    default: '/plans',
  },
};
